import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent, IconName } from '../../ui/icon.component';

interface ContactTile {
  icon: IconName;
  title: string;
  info: string;
  /** Every tile is actionable: tap the phone number to call, the address to navigate. */
  href: string;
  /** Names that action, because a tile that only shows a value does not look tappable. */
  action: string;
  external?: boolean;
}

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent],
})
export class InfoComponent {
  /** The club's fixed weekly schedule. Data, so the markup is one row template. */
  readonly schedule = [
    { day: 'Maandag', times: ['19:00', '20:00'] },
    { day: 'Dinsdag', times: ['10:00', '20:00'] },
    { day: 'Woensdag', times: ['19:00'] },
    { day: 'Donderdag', times: ['19:00', '20:00'] },
  ];

  /**
   * One list, so the four tiles render in one grid. Facebook used to be a second grid of
   * its own below this one, which is why the row never filled out on a laptop.
   */
  readonly content: ContactTile[] = [
    {
      icon: 'phone',
      title: 'Telefoon',
      action: 'Bel ons',
      info: '014/54.50.11',
      href: 'tel:+3214545011',
    },
    {
      icon: 'map-pin',
      title: 'Adres',
      action: 'Toon route',
      info: 'Boskant 14, 2260 Westerlo',
      href: 'https://maps.google.com/?q=Boskant+14,+2260+Westerlo',
      external: true,
    },
    {
      icon: 'envelope',
      title: 'E-mail',
      action: 'Stuur een mail',
      info: 'joeri-gouwkens@hotmail.com',
      href: 'mailto:joeri-gouwkens@hotmail.com',
    },
    {
      icon: 'users',
      title: 'Facebook',
      action: 'Open Facebook',
      info: 'Spinning Heracles',
      href: 'https://nl-be.facebook.com/SpinningHeraclesWesterlo/',
      external: true,
    },
  ];
}
